module.exports = __webpack_public_path__ + "media/music/d4b3ce804680eb7d58f6accc7436e807.mp3";